import { Component, inject, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { RouterOutlet } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-aim';

@Component({
  selector: 'aim-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, ToastModule]
})
export class AppComponent implements OnInit {
  primengConfig = inject(PrimeNGConfig);
  googleAnalyticsService = inject(GoogleAnalyticsService);

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.googleAnalyticsService.initGoogleAnalytics();
  }
}
